import React from 'react'

export default function POListFooterStyle() {
  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #po-list-footer-container {
          display: flex;
          margin-right: 17px;
        }
      `}
      </style>
    </React.Fragment>
  )
}
